<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <FileSlingerListUploader
            category="quality_issue"
            parentId="IYWqBFOCe1UqE0p1nwVleG"
            inputHeight="120px"
            inputWrapperClass="col-12"
            listWrapperClass="col-12"
            wrapperClass="row flex-wrap-reverse"
            :maxItems="10"
            :maxFilesize="10500000"
            :maxTotalFilesize="105000000"
            @update="handleListUpdate"
        ></FileSlingerListUploader>

    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import FileSlingerListUploader from '../s3_files/FileSlingerListUploader.vue'

export default {
    name: 'CustomFormCompTest',
    components: {
        FileSlingerListUploader,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            fieldOne: '',
        }
    },
    computed: {

    },
    mounted: function() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        handleListUpdate(newList) {
            console.log('new list', newList);
        },
    }
}
</script>

<style>

</style>